// Helpers for `time_in_queue` columns, which store a count of seconds in
// the database but are always displayed (and filtered) in days.

export const SECONDS_PER_DAY = 86400

// Convert a stored seconds value to a days-typed display string, e.g.
// `"2 days"` / `"0.5 days"` / `"1 day"`. Returns an empty string for nullish
// or non-numeric inputs.
export function formatSecondsAsDays(seconds) {
  if (seconds === null || seconds === undefined || seconds === '') return ''
  const num = Number(seconds)
  if (Number.isNaN(num)) return ''
  const days = num / SECONDS_PER_DAY
  const display = Number.isInteger(days) ? days : Number(days.toFixed(2))
  const label = display === 1 || display === -1 ? 'day' : 'days'
  return `${display} ${label}`
}
